'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.NanoSlider = void 0;
const $ = require("jquery");
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
const gsap_1 = require("gsap");
const ScrollTrigger_1 = require("gsap/ScrollTrigger");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
class NanoSlider {
    constructor() {
        // -------------------------------------------------
        // デバイス判定
        // -------------------------------------------------
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        // -------------------------------------------------
        // Swiperの初期設定
        // -------------------------------------------------
        const slider = document.querySelector('.bulletNanoSlider');
        if (!slider)
            return;
        const swiperPagination = document.querySelector('.swiper-pagination');
        const swiperNextButton = document.querySelector('.swiper-button-next');
        const swiperPrevButton = document.querySelector('.swiper-button-prev');
        const nanoSwiper = new swiper_1.default(slider, {
            modules: [modules_1.Mousewheel, modules_1.Pagination, modules_1.Navigation],
            loop: false,
            direction: isMobile ? "vertical" : "horizontal", // スマホだったら縦にスライドが進む
            slidesPerView: 1,
            mousewheel: !isMobile, // スマホでは無効化
            allowTouchMove: isMobile, // スマホは指で進む
            speed: 900,
            pagination: isMobile ? false : {
                el: swiperPagination,
                type: "custom",
                renderCustom(swiper, current, total) {
                    // current を 2桁ゼロパディング
                    const padded = String(current).padStart(2, "0");
                    return `<span class="swiper-pagination-current">${padded}</span>`;
                }
            },
            navigation: isMobile ? false : {
                nextEl: swiperNextButton,
                prevEl: swiperPrevButton
            },
            on: {
                init() {
                    const activeSlide = this.slides[this.activeIndex];
                    gsap_1.gsap.set(activeSlide, { opacity: 1, duration: 1 });
                    updateProgressNav(this.activeIndex);
                },
                slideChangeTransitionStart() {
                    const prev = this.slides[this.previousIndex];
                    gsap_1.gsap.to(prev, { opacity: 0, duration: 1 });
                    gsap_1.gsap.set(this.slides[this.activeIndex], { opacity: 0 });
                },
                slideChangeTransitionEnd() {
                    const active = this.slides[this.activeIndex];
                    gsap_1.gsap.to(active, { opacity: 1, duration: 1 });
                    // updateProgressNav(this.activeIndex);
                    const activeSlideEl = this.slides[this.activeIndex];
                    const slideId = activeSlideEl?.id ?? '';
                    const pathname = window.location.pathname;
                    const isEn = pathname.startsWith('/en/');
                    // console.log(isEn);
                    const basePath = isEn
                        ? '/shared/img/content/about_en'
                        : '/shared/img/content/about';
                    console.log(slideId);
                    const path = `${basePath}/progress`;
                    $('.bulletProgressImage').attr('src', `${path}/${slideId}.svg`);
                    const mapPath = `${basePath}/map`;
                    $('.bulletOpenRootMap').attr('src', `${mapPath}/${slideId}.svg`);
                    let body = '';
                    if (this.activeIndex === 0) {
                        body += `<div class="progress__list bulletProgressNumber">1</div>`;
                    }
                    else {
                        for (let i = 1; i <= this.activeIndex + 1; i++) {
                            if (this.activeIndex < i) {
                                body += `<div class="progress__list bulletProgressNumber"><i class="fa-solid fa-check"></i></div>`;
                            }
                            else {
                                body += `<div class="progress__list bulletProgressNumber">${i}</div>`;
                            }
                        }
                    }
                    $('.bulletProgressNumbers').html(body);
                },
            },
        });
        // 「＞」クリックでも次スライドへ移動
        document.querySelectorAll(".trigNextNanoSlide").forEach((el) => {
            el.addEventListener("click", () => {
                nanoSwiper.slideNext();
            });
        });
        // 進捗ナビ更新関数
        function updateProgressNav(activeIndex) {
            const boxes = document.querySelectorAll(".progress__box");
            boxes.forEach((box, i) => {
                const el = box;
                el.dataset.status = i < activeIndex ? "over" : i === activeIndex ? "now" : "yet";
            });
        }
    }
}
exports.NanoSlider = NanoSlider;
exports.default = NanoSlider;
